import React from "react";
import { CurrencyRulesetItem } from "@zapier/payment/esm/hooks/useCurrencyRuleset";
import PaymentMethodImage from "@zapier/payment/esm/components/PaymentMethodImage";
import { CreditCardBrandCode } from "@zapier/payment/esm/types";
import { useTheme } from "@zapier/design-system";

type Props = {
  /** Show small version of images */
  isSmall?: boolean;
  methods: Array<CurrencyRulesetItem>;
  /** All other payment method icons will be greyed out */
  selectedMethod?: CreditCardBrandCode | undefined | null;
};

const wrapperCss = {
  "span + span, span + svg": {
    marginLeft: 15,
  },
};

const rebrandWrapperCss = {
  "span + span, span + svg": {
    marginLeft: 10,
  },
  span: {
    marginBottom: 10,
  },
};

const PaymentMethodImageStrip: React.FC<Props> = ({
  isSmall = false,
  methods = [],
}) => {
  const { isRebrand } = useTheme();
  const images = methods.map((method: CurrencyRulesetItem) => {
    return (
      <PaymentMethodImage
        imageType={method.submethod}
        isSmall={isSmall}
        key={method.submethod}
      />
    );
  });
  return <div css={isRebrand ? rebrandWrapperCss : wrapperCss}>{images}</div>;
};

export default PaymentMethodImageStrip;
